import { gql } from "@apollo/client";

export const POST_TEMPLATE_FOR_MANAGING_FRAGMENT = gql`
  fragment PostTemplateForManagingFragment on PostTemplate {
    id
    name
    title
    data
    updatedAt
    updatedBy {
      id
      user {
        id
        name: fullName
        imageUrl
      }
    }
    department {
      id
      name
    }
  }
`;

export const POST_TEMPLATE_FOR_MANAGING = gql`
  query PostTemplateForManaging($id: ID!) {
    currentOrganization {
      id
      postTemplateById(id: $id) {
        ...PostTemplateForManagingFragment
      }
    }
  }
  ${POST_TEMPLATE_FOR_MANAGING_FRAGMENT}
`;
